import { postMessageToChild } from './infrastructure';
export function postGenericMessage(microFrontName, data) {
    postMessageToChild(microFrontName, data);
}
//# sourceMappingURL=messages.js.map